import { render } from "./RenderingViewButtons.vue?vue&type=template&id=25bb7546&ts=true"
import script from "./RenderingViewButtons.vue?vue&type=script&lang=ts"
export * from "./RenderingViewButtons.vue?vue&type=script&lang=ts"

import "./RenderingViewButtons.vue?vue&type=style&index=0&id=25bb7546&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__